<template>
  <div class="analyse-root">
    <div class="desc-text">{{ $t('analyse_desc_1') }}</div>
    <div class="checkbox-con">
      <md-checkbox class="md-checkbox" v-model="analyseType" value="HSK" @change="changeType('HSK')"
        >HSK</md-checkbox
      >
      <md-checkbox class="md-checkbox" v-model="analyseType" value="YCT" @change="changeType('YCT')"
        >YCT</md-checkbox
      >
    </div>
    <div class="desc-text" v-show="!getResult">
      {{ $t('analyse_desc_2', { maxCount: maxCharacters }) }}
    </div>
    <el-input
      v-show="!getResult"
      type="textarea"
      :placeholder="$t('analyse_input_placeholder')"
      v-model="inputVal"
      height="180"
      :maxlength="maxCharacters"
      show-word-limit
      rows="7"
    >
    </el-input>

    <div v-show="getResult" class="result-con">
      <div class="player-con">
        <FullPlayer
          :soundUrl="soundUrl"
          :simpleType="false"
          :fatherPause="fatherPause"
          :soundName="inputVal"
        ></FullPlayer>
      </div>

      <!-- 文章匹配词 -->
      <div class="participle-match-con">
        <span
          v-for="(item, index) in participleMatch"
          :key="index"
          :class="[item?.background ? 'active-character' : 'participle-character']"
          :style="{ background: item?.background }"
        >
          {{ item?.word }}
        </span>
      </div>
      <!-- 匹配计数 -->
      <div class="level-count-con">
        <div class="level-count-total">
          <p
            v-for="(level, index) in levelCounts"
            :key="index"
            @click="changeActiveLevel(level)"
            class="level-total-item"
            :class="{ activeTriangle: activeLevelId == level?.id }"
            :style="{ background: level?.background }"
          >
            {{ level?.level_name }}<span>{{ level?.word_count }}</span>
          </p>
        </div>
        <div class="level-count-detail">
          <span v-for="(item, index) in activeLevelCountDetail" :key="index"
            >{{ item.word }}&nbsp;({{ item.count }})&nbsp;;&nbsp;
          </span>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="button-con" v-show="!getResult">
      <div
        class="fp-button fp-submit-btn"
        @click="clickAnalyse"
        :disabled="submitLoading || !inputVal"
      >
        <span v-if="submitLoading"> <i class="el-icon-loading"></i>{{ $t('loading') }}</span>
        <span v-else>{{ $t('analyse_title') }}</span>
      </div>
      <div class="fp-button fp-cancel-btn" @click="goBack">{{ $t('change_lang_cancel') }}</div>
    </div>
    <div class="button-con" v-show="getResult">
      <div class="fp-button fp-submit-btn" @click="clickEdit">
        <span>{{ $t('edit_message_edit1') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { analyseSentence } from '@/serves/api/freePractice'
import FullPlayer from '@/components/freePractice/common/fullPlayer'
export default {
  data() {
    return {
      soundUrl: '',
      levelColor: {
        1: '#5C990C',
        2: '#039DEE',
        3: '#BA75FF',
        4: '#F9A349',
        5: '#860013',
        6: '#995B16',
        12: '#E97582',
        7: '#5C990C',
        9: '#039DEE',
        10: '#BA75FF',
        11: '#F9A349',
      },
      maxCharacters: 500,
      submitLoading: false,
      getResult: false,
      analyseType: 'HSK',
      inputVal: '',
      participleMatch: [],
      levelCounts: [],
      activeLevelId: '1',
      activeLevelCountDetail: [],
      fatherPause: false,
      loadIndex: '',
    }
  },
  methods: {
    changeActiveLevel(level) {
      this.activeLevelId = level.id
      this.activeLevelCountDetail = level.countArr
    },
    changeType(e) {
      if (this.getResult) {
        this.analyseType = e
        this.clickAnalyse()
      } else {
        this.analyseType = e
      }
    },
    clickAnalyse() {
      if (this.submitLoading) return
      if (this.inputVal == '') return
      this.submitLoading = true
      this.loadIndex = window.layer.load(3)
      analyseSentence({ text_type: this.analyseType, text: this.inputVal })
        .then((res) => {
          if (res.errcode == 0) {
            this.soundUrl = res.data.tts_url
            this.participleMatch = []

            const participleMatch = res.data.participle_match
            const printicipleCountObj = {}
            const levelMap = res.data.level_count_map
            const tempLevelCountObj = {} // 暂存各个级别的匹配词汇
            // 计数转对象-方便查找
            res.data.participle.forEach((item) => {
              let key = item.word
              printicipleCountObj[key] = item
            })

            let len = participleMatch.length
            let lastType = 'match' // match/nomatch/
            let pointer = -1

            for (let i = 0; i < len; i++) {
              if (!participleMatch[i].level_id) {
                // 未匹配到级别
                if (lastType == 'noMatch') {
                  // 上一个未匹配到级别，合并, 减少dom
                  this.participleMatch[pointer].word =
                    this.participleMatch[pointer].word + participleMatch[i].word
                } else {
                  pointer++
                  this.participleMatch[pointer] = participleMatch[i]
                }
                lastType = 'noMatch'
              } else {
                // 匹配到级别
                // 赋值颜色
                pointer++
                lastType = 'match'
                let itemId = participleMatch[i].level_id
                participleMatch[i].background = this.levelColor[itemId]
                this.participleMatch[pointer] = participleMatch[i]
                // 次数存入对应级别
                let countObj = printicipleCountObj[participleMatch[i].word]
                if (!tempLevelCountObj[itemId]) {
                  tempLevelCountObj[itemId] = new Map()
                }
                tempLevelCountObj[itemId].set(countObj.word, countObj)
              }
              console.log(i, participleMatch[i], this.participleMatch[pointer])
            }

            levelMap.forEach((level) => {
              if (level.level_name) {
                level.level_name = level.type_name + ' ' + level.level_name.replace(/[a-zA-Z]/g, '')
              }
              if (tempLevelCountObj[level.id]) {
                level.countArr = Array.from(tempLevelCountObj[level.id], (item) => {
                  return item[1]
                })
              }
              level.background = this.levelColor[level.id]
            })

            this.levelCounts = levelMap
            this.changeActiveLevel(levelMap[0])
            this.getResult = true
          } else {
            this.$message.error(res.errmsg)
          }
          console.log(res)
        })
        .catch((err) => {
          console.log(err)
          this.$message.error(err)
        })
        .finally(() => {
          this.submitLoading = false
          window.layer.close(this.loadIndex)
        })
    },
    goBack() {
      this.$emit('goBack')
    },
    clickEdit() {
      this.getResult = false
      this.fatherPause = !this.fatherPause
    },
  },
  mounted() {},
  components: {
    FullPlayer,
  },
}
</script>
<style lang="scss" scoped>
@import './styles/freePractice.scss';
.analyse-root {
  padding: 45px 27px 0;
  .desc-text {
    font-size: 16px;
    color: #000;
    margin-bottom: 16px;
  }
  .checkbox-con {
    margin-bottom: 28px;
    width: 210px;
    display: flex;
    justify-content: space-between;
  }
  .button-con {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 30px;
  }
  .result-con {
    background: #fafafb;
    padding: 14px 20px 0;
    border-radius: 4px;
    .player-con {
      padding: 17px 16px 24px 20px;
      background: #fff;
      margin-bottom: 18px;
      border-radius: 2px;
    }
  }
  .participle-match-con {
    align-items: center;
    margin-bottom: 60px;
    .participle-character {
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #000;
      margin: 2px;
    }
  }
  .active-character {
    padding: 0px 8px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-size: 16px;
    display: inline-block;
    border-radius: 2px;
    margin: 2px;
  }
  .level-count-con {
    background: #474b64;
    padding: 20px 18px;
    border-radius: 3px;
  }
  .level-count-total {
    display: flex;
    margin-bottom: 20px;
  }
  .level-total-item {
    width: 105px;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    font-size: 16px;
    font-weight: 600;
    padding-left: 12px;
    margin-right: 12px;
    color: #fff;
    position: relative;
    cursor: pointer;
    span {
      font-size: 14px;
      font-weight: 400;
      // line-height: 32px;
      position: absolute;
      right: 12px;
      top: 0px;
      opacity: 0.8;
    }
  }
  .level-total-item::after {
    content: '';
    position: absolute;
    border-color: transparent transparent rgba(255, 255, 255, 0.14) transparent;
    border-width: 10px;
    border-style: solid;
    left: 38px;
    width: 20px;
    height: 20px;
    transition: bottom 0.25s ease-out, opacity 0.01s ease-out 0.01s;
    opacity: 0;
    pointer-events: none;
    bottom: -40px;
    transition: bottom 0.25s ease-out, opacity 0.01s ease-out 0.01s;
  }
  .activeTriangle.level-total-item::after {
    bottom: -20px;
    opacity: 1;
    transition: bottom 0.25s ease-out, opacity 0.01s ease-out 0.15s;
  }
  .level-count-detail {
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    padding: 16px;
    font-size: 16px;
    line-height: 32px;
    min-height: 120px;
    border-radius: 3px;
  }
  ::v-deep.el-textarea.el-textarea__inner {
    background: #fafafb !important;
    border-color: #fafafb !important;
  }
}
.md-checkbox {
  margin-right: 5px;
  // 动画不支持，所以隐藏动画，否则会造成元素闪显闪隐
  ::v-deep .md-ripple {
    display: none;
  }

  ::v-deep .md-checkbox-label {
    padding-left: 12px;
    color: #696974;

    font-size: 14px;
    font-weight: 500;
  }

  ::v-deep .md-checkbox-container {
    border-radius: 50%;
  }

  &.md-checked {
    ::v-deep .md-checkbox-container {
      background-color: $success !important;
      border-color: $success !important;
    }
  }
}
</style>
